export const INDUSTRY_SET_INITIAL_STATE = 'INDUSTRY_SET_INITIAL_STATE';
export const INDUSTRY_FIND_ALL = 'INDUSTRY_FIND_ALL';
export const INDUSTRY_VIEW = 'INDUSTRY_VIEW';
